<template>
  <div v-if="get_data">
    <div class="text-center">
      <a
        v-for="(country, index) in displayed_country_badges"
        :key="index"
        @click="selectFilter(country, index)"
        class="btn-filter"
      >
        <badge
          v-if="country.results_count"
          class="ml-1 my-1 badge-lg bg-gradient-primary"
          rounded
          >{{ country.display_name }}
          {{
            country.results_count != null || country.results_count != undefined
              ? `(${country.results_count})`
              : ``
          }}</badge
        > </a
      ><br />
      <a class="pointer" v-if="show_more" @click="showMore()" type="icon"
        ><i class="fa fa-chevron-down"></i
      ></a>
      <a class="pointer" v-if="show_less" @click="l = default_l" type="icon"
        ><i class="fa fa-chevron-up"></i
      ></a>
    </div>
  </div>
</template>

<script>
export default {
  props: ["country_list", "selected"],
  emits: ["update:onSelect"],
  data: () => ({
    default_l: 5,
    l: 5,
    increment: 5,
    max: 200
  }),
  mounted() {
    this.l = this.default_l;
  },
  computed: {
    get_data() {
      var d = [];
      d.push(...this.country_list);
      if (d && d[0]) {
        if (d[0].results_count == null || d[0].results_count == undefined) {
          return null;
        }
      }
      d = this.sort(d, "country_name");
      if (this.l > this.max) {
        return d.slice(0, this.max);
      }
      return d.slice(0, this.l);
    },
    country_badges() {
      if (!this.selected || this.selected.length === 0) return [];

      const isAllCountries = this.selected.some(
        item =>
          item.record_number === "" || item.country_name === "All countries"
      );

      const explicitlySelectedCountries = this.selected.filter(
        item =>
          !item.isState &&
          item.country_name !== "All countries" &&
          item.record_number !== ""
      );
      const selectedStates = isAllCountries
        ? []
        : this.selected.filter(item => item.isState);

      const countriesCount = explicitlySelectedCountries.length;
      const res = [];

      // Group selected states by parent country
      const statesByCountry = {};
      selectedStates.forEach(s => {
        if (!statesByCountry[s.parent_country]) {
          statesByCountry[s.parent_country] = [];
        }
        statesByCountry[s.parent_country].push(s);
      });

      if (isAllCountries) {
        this.country_list.forEach(country => {
          if (country.results_count > 0) {
            res.push({
              ...country,
              display_name: country.country_name
            });
          }
        });
        return res;
      }

      this.country_list.forEach(country => {
        const isExplicitlySelected = explicitlySelectedCountries.some(
          c => c.record_number == country.record_number
        );
        const selectedStatesForThisCountry =
          statesByCountry[country.country_name] || [];

        if (isExplicitlySelected) {
          if (countriesCount > 1) {
            // RULE: If >1 country selected, show country badge (suppress states for this country)
            if (country.results_count > 0) {
              res.push({
                ...country,
                display_name: country.country_name
              });
            }
          } else {
            // RULE: If exactly 1 country selected, show states that have results (as before)
            const statesWithResults = (country.states || []).filter(
              s => s.results_count > 0
            );
            if (statesWithResults.length > 0) {
              statesWithResults.forEach(s => {
                res.push({
                  ...s,
                  display_name: s.state_name || s.name
                });
              });
            } else if (country.results_count > 0) {
              res.push({
                ...country,
                display_name: country.country_name
              });
            }
          }
        } else {
          // RULE: Country NOT explicitly selected. Show state badges if any.
          selectedStatesForThisCountry.forEach(s => {
            if (s.results_count > 0) {
              res.push({
                ...s,
                display_name: s.state_name || s.name
              });
            }
          });
        }
      });

      return res;
    },
    displayed_country_badges() {
      let res = this.country_badges;
      if (this.l > this.max) {
        return res.slice(0, this.max);
      }
      return res.slice(0, this.l);
    },
    show_more() {
      if (this.l >= this.country_badges.length) {
        return false;
      }
      if (this.l >= this.max) {
        return false;
      }
      return true;
    },
    show_less() {
      if (this.l >= this.max && this.default_l != this.max) {
        return true;
      }
      if (
        this.l >= this.country_badges.length &&
        this.country_badges.length > this.default_l
      ) {
        return true;
      }
      return false;
    }
  },
  methods: {
    sort(array, key) {
      return array.sort(function(a, b) {
        var x = a[key];
        var y = b[key];
        return x > y ? 1 : x < y ? -1 : 0;
      });
    },
    getType(country) {
      if (country) {
        return "info";
      }
    },
    showMore() {
      if (this.l < this.max) {
        this.l += this.increment;
      }
    },
    isSelected(item) {
      let res = false;
      this.selected.forEach(e => {
        if (e.record_number == item.record_number) {
          res = true;
        }
      });
      return res;
    },
    selectFilter(item) {
      this.$emit("update:onSelect", item);
    }
  }
};
</script>

<style scoped>
.pointer:hover {
  cursor: pointer;
}
</style>
